import { polygon } from '@turf/turf';

export function toTurfPolygon(polygonPath) {
  let points = polygonPath.map((point) => [point.lng(), point.lat()]);
  return polygon([[...points, points[0]]]);
}
